<div class="footerContainer">
  <div class="flex-display justify-content-center overflow-auto">
    <a class="cursor-pointer" *ngFor="let obj of footerLinkData" [tabindex]="obj.displayText ? '' : '-1' "  [ngClass]="obj.displayText ? 'footer-item' : 'footer-line'" [class.bold]="obj.isBold"  (contextmenu)="onRightClick($event,obj)" (click)="footer(obj,$event)" (keyup.enter)="footer(obj,$event)">
      {{obj.displayText}}
    </a>
  </div>
</div>
<div class="footer-bread-crumb-container" *ngIf="(navData && navData.crumbData != null) || printOption || displayOption">
  <div *ngIf="!(navData && navData.crumbData != null)" class="w-63 float-L"></div>
  <div *ngIf="navData && navData.crumbData != null" class="w-63 float-L">
    <div *ngIf="navData.crumbData.length > 0" class="footer-bread-crumb-container">
      <div *ngFor="let crumbObj of navData.crumbData, index as i" class="bread-crumb" [class.bread-crumb-selected]="i === (navData.crumbData.length - 1)" [class.border-bottom-help]="i === (navData.crumbData.length - 1)">
        <div tabindex="0" class="bread-crumb-text flex-display" (keyup.enter)="footerMenuClicked(i === (navData.crumbData.length - 1))" (click)="footerMenuClicked(i === (navData.crumbData.length - 1))">
          <div class="overflow-elipses bread-crumb-linked border-bottom-help" (click)="navigateToTOC(crumbObj)" *ngIf="crumbObj!=undefined &&(!crumbObj.split(' ')[0].includes('X')) && crumbObj != navData.crumbData[0] && crumbObj != navData.crumbData[navData.crumbData.length - 1] && navData.crumbData[0] != 'Other Sources'">
            {{crumbObj}}
          </div>
          <div class="overflow-elipses" *ngIf="(((crumbObj == navData.crumbData[0] || crumbObj == navData.crumbData[navData.crumbData.length - 1]) || (navData.crumbData[0] == 'Other Sources')) && (navData.menuData != null)) || (crumbObj.split(' ')[0].includes('X'))">
            {{crumbObj}}
          </div>
          <div class="overflow-elipses" (click)="navigateToTOC(crumbObj)" *ngIf="((crumbObj == navData.crumbData[0] || crumbObj == navData.crumbData[navData.crumbData.length - 1])) && (navData.menuData == null)">
            {{crumbObj}}
          </div>
          <div class="font-14">
            <mat-icon *ngIf="i === (navData.crumbData.length - 1) && !showFooterMenu && navData.menuData != null" [inline]="true">keyboard_arrow_up</mat-icon>
            <mat-icon *ngIf="i === (navData.crumbData.length - 1)&& showFooterMenu && navData.menuData != null" [inline]="true">keyboard_arrow_down</mat-icon>
          </div>
        </div>
        <div *ngIf="i != (navData.crumbData.length - 1)">
          <img src="../../../assets/icons/Arrow Right (Alt).svg" class="bread-crumb-icon" alt="Arrow Right">
        </div>
        <div *ngIf="showFooterMenu && (i === (navData.crumbData.length - 1)) && navData.menuData != null" class="footer-menu-container">
          <div class="flex-display justify-content-flex-end" (click)="closeFooterMenu()" (keyup.enter)="closeFooterMenu()">
            <button mat-raised-button id="close-footer-menu-btn">
              Close <img src="../../../assets/icons/temp/close-white.svg" class="close-icon-image" alt="Close Left Menu Option">
            </button>
          </div>
          <div class="footer-menu-data-container">
            <div *ngFor="let obj of breadCrumbMenuData" (click)="ChangeSelectedItem(obj)" (keyup.enter)="ChangeSelectedItem(obj)" class="footer-menu-element flex-display" tabindex="0">
              <div class="align-self-center bread-crump-popup-text footer-menu-item" [class.footer-menu-element-disabled]="crumbObj === obj.menuItem || obj.menuUrl === '' || obj.menuUrl == null">
                {{obj.menuItem}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="float-R" *ngIf="printOption">
    <div class="footer-bread-crumb-data-print-display">
      <div (click)="footerPrintClicked()" class="bread-crumb"  (keyup.enter)="footerPrintClicked()">
        <div *ngIf="showFooterPrintMenu" class="footer-menu-container">
          <div class="flex-display justify-content-flex-end">
            <button mat-raised-button id="close-footer-menu-btn">
              Close <img src="../../../assets/icons/temp/close-white.svg" class="close-icon-image" alt="Close Print Option">
            </button>
          </div>
          <div class="footer-menu-data-container">
            <div *ngFor="let printobj of PrintValue; let i = index">
              <div class="footer-menu-display-element flex-display print-display" *ngIf="printobj.DisplayOrNot">
                <div class="align-self-center bread-crump-popup-text footer-menu-item" (click)="printpreview(printobj)" (Key.enter)="printpreview(printobj)" tabindex="0">
                  {{ printobj.labels }}  <span *ngIf="printQueueCount > 0 && printobj.deletedIcon">({{printQueueCount}})</span>
                </div>
                <div *ngIf="printobj.deletedIcon" class="flex-display-print-trash">
                  <img src="../../../assets/icons/trash-red.svg" class="close-icon-image cursor-pointer" alt="Delete" title="Delete" (click)="deletePrintQueue(printobj)" (keyup.enter)="deletePrintQueue(printobj)" tabindex="0">
                </div>
              </div>
            </div>
          </div>          
        </div>
        <div class="bread-crumb-selected border-bottom-help flex-display" tabindex="0" >
          <img src="../../../assets/icons/Print-black.svg" class="close-icon-image" alt="Print"><span class="close-icon-image border-bottom-help">
          {{globalprint}}  <label *ngIf="printQueueCount > 0">({{printQueueCount}})</label></span>
          <div class="font-14">
            <mat-icon *ngIf="!showFooterPrintMenu" [inline]="true">keyboard_arrow_up</mat-icon>
            <mat-icon *ngIf="showFooterPrintMenu" [inline]="true">keyboard_arrow_down</mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="float-R" *ngIf="displayOption">
    <div class="footer-bread-crumb-data-print-display">
      <div class="bread-crumb">
        <div (click)="footerDisplayClicked()" (keyup.enter)="footerDisplayClicked()" tabindex="0">
          <div *ngIf="showFooterDisplayMenu" class="footer-menu-container">
            <div class="flex-display justify-content-flex-end">
              <button mat-raised-button id="close-footer-menu-btn">
                Close <img src="../../../assets/icons/temp/close-white.svg" class="close-icon-image" alt="Close Display Option">
              </button>
            </div>
            <div class="footer-menu-data-container">
              <div *ngFor="let obj of DisplayValue; let i = index">
                <div class="print-display" *ngIf="obj.DisplayOrNot">
                  <div class="footer-menu-display-element flex-display" (click)="displayAll(obj)" (keyup.enter)="displayAll(obj)" tabindex="0">
                    <div class="align-self-center mr-5">
                      <img src="{{obj.imgPath}}" class="flex-display-icon" alt="{{obj.alt}}" />
                    </div>
                    <div id="{{obj.id}}" class="align-self-center bread-crump-popup-text footer-menu-item print-display float-R">
                      {{obj.labels}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bread-crumb-selected border-bottom-help flex-display" tabindex="0">
            <img src="../../../assets/icons/Display-black.svg" class="close-icon-image" alt="Display"><span class="close-icon-image border-bottom-help">{{displayLabel}}</span>
            <div class="font-14">
              <mat-icon *ngIf="!showFooterDisplayMenu" [inline]="true">keyboard_arrow_up</mat-icon>
              <mat-icon *ngIf="showFooterDisplayMenu" [inline]="true">keyboard_arrow_down</mat-icon>
            </div>
          </div>
        </div>
        <div class="hidden-content-sec" *ngIf="hiddenContentSECFlag">{{hiddenContentSECText}}</div>
      </div>
    </div>
  </div>
</div>
  
